export class ServiceShiftWork {
    room = null;
    specialist = null;
    service = null;
    shiftWorkingTime = null;
    parentId = null;
    fromDate = null;
    repeatType = null;
    duration = null;
    maxNumber = null;
}